var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVueListe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.7 23.3",
    style: {
      enableBackground: "new 0 0 23.7 23.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M8.4,3.7h13.8c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3H8.4c-0.7,0-1.3,0.6-1.3,1.3S7.7,3.7,8.4,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M22.2,10.4H8.4c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h13.8c0.7,0,1.3-0.6,1.3-1.3S22.9,10.4,22.2,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M22.2,19.6H8.4c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h13.8c0.7,0,1.3-0.6,1.3-1.3S22.9,19.6,22.2,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M3.9,0.2H1.1C0.6,0.2,0.3,0.6,0.3,1v2.8c0,0.5,0.4,0.8,0.8,0.8h2.8c0.5,0,0.8-0.4,0.8-0.8V1 C4.7,0.6,4.4,0.2,3.9,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M3.9,9.4H1.1c-0.5,0-0.8,0.4-0.8,0.8v2.8c0,0.5,0.4,0.8,0.8,0.8h2.8c0.5,0,0.8-0.4,0.8-0.8v-2.8 C4.7,9.8,4.4,9.4,3.9,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M3.9,18.7H1.1c-0.5,0-0.8,0.4-0.8,0.8v2.8c0,0.5,0.4,0.8,0.8,0.8h2.8c0.5,0,0.8-0.4,0.8-0.8v-2.8 C4.7,19.1,4.4,18.7,3.9,18.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueListe);
export default __webpack_public_path__ + "static/media/Vue_Liste.35333958.svg";
export { ForwardRef as ReactComponent };